import { MapSiteDataPreview } from '../../../../models';

/* istanbul ignore file */
export class MapSiteDataPreviewLogicServiceModel {
    currentMapSiteDataPreview = new MapSiteDataPreview();
}
